import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  MiniStressTypeInfoData,
  ActionType,
  IMiniStressTypeInfoResponse,
} from "models/stressCheck/miniStressInformation";
import { httpStatus } from "configs/httpStatus";
import { getMiniStressTypeInfoRequests } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressTypeInfoActions";

function* miniStressCheckTypeInfoSaga({
  payload,
}: {
  payload: MiniStressTypeInfoData;
}) {
  try {
    const response: IMiniStressTypeInfoResponse = yield call(
      getMiniStressTypeInfoRequests,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetMiniStressCheckTypeInfoWatcher() {
  yield takeLatest(
    ActionType.MINI_STRESS_INFO as any,
    miniStressCheckTypeInfoSaga
  );
}

export default [fork(onGetMiniStressCheckTypeInfoWatcher)];
